



































































































































































import { secondaryBody, primaryBody } from "@/helpers/styleClassHelpers";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getFieldContent } from "@/helpers/utils";
import DataTableCustom from "./DataTableCustom.vue";
import CustomCheckbox from "./Checkbox.vue";
import { BPagination } from "bootstrap-vue";
import GuideBalloon from "./GuideBalloon.vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

type TableVariant = "primary" | "secondary";

@Component({
	components: {
		"data-table-custom": DataTableCustom,
		"custom-checkbox": CustomCheckbox,
		BPagination,
		GuideBalloon,
	},
})
export default class Table extends Vue {
	@Prop({ default: () => [] }) headers!: any;
	@Prop({ default: () => [] }) tableData!: any;
	@Prop({ default: "primary" }) variant!: TableVariant;
	@Prop() synchronizeSelected: boolean;
	@Prop({ default: () => null }) onClickLine!: (data: any) => void;

	secondaryBody = secondaryBody;
	primaryBody = primaryBody;

	getFieldContent = getFieldContent;

	selectAll: string[] = [];
	selected: any[] = [];
	subMenuOpen = {} as any;

	toggleSelectAll() {
		if (this.selectAll.length) {
			this.selected = [...this.tableData];
		} else {
			this.selected = [];
		}
	}

	toggleSelect() {
		if (this.selected.length !== this.tableData.length) {
			this.selectAll = [];
		} else {
			this.selectAll = ["selectAll"];
		}
	}

	tableRowStyle(kind?: string, style?: string) {
		switch (kind || style) {
			case "buttonSize":
				return "w-32 whitespace-nowrap pr-4";
			case "value":
				return ["whitespace-nowrap"];
			case "bold":
				return "font-bold";
			default:
				return "";
		}
	}

	mounted() {
		window.addEventListener("click", this.clickOut);
	}

	openSubMenu(header: any) {
		if (header === this.subMenuOpen) {
			this.subMenuOpen = {};
		} else {
			this.subMenuOpen = header;
		}
	}

	clickOut(e: any) {
		// Usa composedPath() para compatibilidade com navegadores modernos (e.path está obsoleto)
		const path = e.composedPath ? e.composedPath() : e.path || [];
		// Verifica se o clique foi dentro de algum elemento do menu (itemMenu ou subMenu)
		const clickedInsideMenu = path.some((el: any) => el.id === "itemMenu" || el.id === "subMenu");
		// Se clicou fora do menu, fecha o submenu aberto
		if (!clickedInsideMenu) {
			this.subMenuOpen = {};
		}
	}

	onClick(option: any) {
		this.$emit("clickOption", option);
	}

	actionsEvent(event: string, data: any) {
		this.$emit("actionsEvent", event, data);
	}

	onActionTagClick(payload: { key: string; data: any }) {
		this.$emit("actionTagClick", payload);
	}

	clickItemHeader(header: any) {
		this.$emit("clickItemHeader", header);
	}

	addOptionAll(options: any[]) {
		if (!options || !options.length) {
			return [];
		}
		return [{ name: "Todos", value: "all" }, ...options];
	}

	@Watch("selected")
	emitSelected() {
		this.$emit("updateSelected", this.selected);
	}

	@Watch("synchronizeSelected")
	clearSelected() {
		this.selected = [];
		this.selectAll = [];
	}

	beforeDestroy() {
		window.removeEventListener("click", this.clickOut);
	}
}
